import { DataValue } from '@apollo/client/react/hoc';
import React from 'react';

import { ErrorInternalServer } from 'src/app/components/Error/ErrorInternalServer';
import { LoaderPage } from 'src/app/components/Loader/LoaderPage';
import { PopupErrorInternet } from 'src/app/components/Popup/PopupErrorInternet';
import { isClientOnline } from 'src/app/helpers/device';

export function withGraphQLLoader({ name }: { name: string; } = { name: 'data' }): <C>(WrappedComponent: C) => C {
  function wrappedComponent<C>(WrappedComponent: C): C;
  function wrappedComponent<P>(WrappedComponent: React.ComponentType<P>): React.ComponentClass<P> {
    type MyProps = P;

    interface MyState {
      isFirstLoad: boolean;
    }

    class MyClassWithGraphQLLoader extends React.Component<MyProps, MyState> {
      constructor(props: MyProps) {
        super(props);

        this.state = {
          isFirstLoad: true
        };
      }

      componentDidUpdate(): void {
        const data: DataValue<{}> = this.props[name];
        if (!data.loading && this.state.isFirstLoad) {
          this.setState({
            isFirstLoad: false
          });
        }
      }

      render(): JSX.Element {
        const data: DataValue<{}> = this.props[name];
        const isError = data.error &&
          (!!data.error.networkError || data.error.graphQLErrors.length > 0);

        if (data.loading && this.state.isFirstLoad) {
          return <LoaderPage />;
        } else if (isError && isClientOnline()) {
          return <ErrorInternalServer />;
        } else if (isError) {
          return (
            <PopupErrorInternet />
          );
        }

        return (
          <>
            <WrappedComponent {...this.props} />
            {data.loading && <LoaderPage />}
          </>
        );
      }
    }

    return MyClassWithGraphQLLoader;
  }

  return wrappedComponent;
}
